import { RemoveDynamicAttributeGroupButton } from "@/modules/dynamic-attributes/feature/remove-dynamic-attribute-group";
import { useSelectedGroupId } from "../model/selected-group/use-selected-group-id";
import { useSelectAllGroup } from "../model/selected-group/use-select-all-group";

export function DeleteGroupButton() {
  const groupId = useSelectedGroupId();
  const { selectAllGroup } = useSelectAllGroup();

  if (!groupId) {
    return null;
  }

  return (
    <RemoveDynamicAttributeGroupButton
      afterSubmit={selectAllGroup}
      type="text"
      groupId={groupId}
    />
  );
}
